(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elation-product-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.elation-product-details[data-animate-section]');
    if (!section) return;

    const content = section.querySelector('.elation-product-details__content');
    if (content) {
      // Transform H3 headings into feature cards
      transformFeatureCards(content);

      // Transform callout paragraphs
      transformCalloutBoxes(content);

      // Enhance list styling to 2-column grid
      enhanceListStyling(content);
    }

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      section.classList.add('elation-details-animate');
      return;
    }

    // Feature detect IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      section.classList.add('elation-details-animate');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('elation-details-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(section);
  });

  // Transform H3 + paragraph into feature cards with icons
  function transformFeatureCards(content) {
    const h3Elements = content.querySelectorAll('h3');

    h3Elements.forEach(h3 => {
      const nextElement = h3.nextElementSibling;
      if (nextElement && nextElement.tagName === 'P') {
        const title = h3.textContent.trim();
        const description = nextElement.textContent.trim();
        const icon = mapKeywordToIcon(title.toLowerCase());

        const card = document.createElement('div');
        card.className = 'elation-details-feature-card';
        card.innerHTML = `
          <div class="elation-details-feature-card__icon-container">
            ${getBenefitIconSVG(icon)}
          </div>
          <div class="elation-details-feature-card__content">
            <h4 class="elation-details-feature-card__title">${title}</h4>
            <p class="elation-details-feature-card__description">${description}</p>
          </div>
        `;

        h3.replaceWith(card);
        nextElement.remove();
      }
    });
  }

  // Map keywords to icon names
  function mapKeywordToIcon(text) {
    if (text.includes('science') || text.includes('research') || text.includes('study') || text.includes('clinical')) return 'microscope';
    if (text.includes('test') || text.includes('lab') || text.includes('formula')) return 'flask';
    if (text.includes('verified') || text.includes('approved') || text.includes('certified')) return 'clipboard-check';
    if (text.includes('safe') || text.includes('quality') || text.includes('guarantee')) return 'shield-check';
    if (text.includes('award') || text.includes('premium') || text.includes('best')) return 'award';
    if (text.includes('natural') || text.includes('plant') || text.includes('botanical')) return 'plant';
    if (text.includes('growth') || text.includes('nurture') || text.includes('develop')) return 'seedling';
    if (text.includes('rating') || text.includes('review') || text.includes('top')) return 'star';
    if (text.includes('energy') || text.includes('power') || text.includes('boost')) return 'zap';
    if (text.includes('focus') || text.includes('mental') || text.includes('cognitive') || text.includes('brain')) return 'brain';
    if (text.includes('hydrat') || text.includes('moisture') || text.includes('water')) return 'water';
    if (text.includes('active') || text.includes('performance') || text.includes('athletic')) return 'pulse';
    if (text.includes('recover')) return 'recovery';
    if (text.includes('clarity')) return 'clarity';
    return 'shield-check'; // default
  }

  // Get benefit icon SVG
  function getBenefitIconSVG(iconName) {
    const icons = {
      'microscope': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18h8"/><path d="M3 22h18"/><path d="M14 22a7 7 0 1 0 0-14h-1"/><path d="M9 14h2"/><path d="M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z"/><path d="M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3"/></svg>',
      'flask': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6"/><path d="M10 3v5.586a1 1 0 0 0 .293.707l4.414 4.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2v-4.586a1 1 0 0 1 .293-.707l4.414-4.414A1 1 0 0 0 14 8.586V3"/><line x1="9" y1="16" x2="15" y2="16"/></svg>',
      'clipboard-check': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/></svg>',
      'shield-check': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
      'award': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>',
      'plant': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 20h10"/><path d="M10 20c5.5-2.5.8-6.4 3-10"/><path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"/><path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"/></svg>',
      'seedling': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 10a6 6 0 0 0-6-6H3v2a6 6 0 0 0 6 6h3z"/><path d="M12 14a6 6 0 0 1 6-6h3v2a6 6 0 0 1-6 6h-3z"/><path d="M12 22v-8"/></svg>',
      'star': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
      'zap': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
      'brain': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/></svg>',
      'water': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>',
      'pulse': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>',
      'recovery': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>',
      'clarity': '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>'
    };
    return icons[iconName] || icons['shield-check'];
  }

  // Transform paragraphs starting with <strong> into callout boxes
  function transformCalloutBoxes(content) {
    const paragraphs = content.querySelectorAll('p');

    paragraphs.forEach(p => {
      const firstChild = p.firstElementChild;
      if (firstChild && firstChild.tagName === 'STRONG') {
        const callout = document.createElement('div');
        callout.className = 'elation-details-callout';

        const heading = document.createElement('div');
        heading.className = 'elation-details-callout__heading';
        heading.textContent = firstChild.textContent;

        const text = document.createElement('div');
        text.className = 'elation-details-callout__text';

        // Clone paragraph content without the strong tag
        const pClone = p.cloneNode(true);
        pClone.removeChild(pClone.firstElementChild);
        text.innerHTML = pClone.innerHTML.trim();

        callout.appendChild(heading);
        callout.appendChild(text);

        p.replaceWith(callout);
      }
    });
  }

  // Enhance list styling to 2-column grid
  function enhanceListStyling(content) {
    const lists = content.querySelectorAll('ul');

    lists.forEach(list => {
      list.classList.add('elation-details-enhanced-list');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elation-product-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.elation-product-ingredients[data-animate-section]');
    if (!section) return;

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      section.classList.add('elation-ingredients-animate');
      return;
    }

    // Feature detect IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      section.classList.add('elation-ingredients-animate');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('elation-ingredients-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elation-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tabBars = document.querySelectorAll('.elation-tabs__bar');

    tabBars.forEach(function (bar) {
      var tabs = bar.querySelectorAll('.elation-tabs__tab');
      var section = bar.closest('.elation-tabs');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('elation-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });

          tab.classList.add('elation-tabs__tab--active');
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');

          var panels = section.querySelectorAll('.elation-tabs__panel');

          panels.forEach(function (p) {
            p.classList.remove('elation-tabs__panel--active');
            p.hidden = true;
          });

          var target = section.querySelector('#' + tab.getAttribute('aria-controls'));

          if (target) {
            target.classList.add('elation-tabs__panel--active');
            target.hidden = false;
          }
        });

        tab.addEventListener('keydown', function (e) {
          var tabArray = Array.from(tabs);
          var index = tabArray.indexOf(tab);
          var next;

          if (e.key === 'ArrowRight') {
            next = tabArray[(index + 1) % tabArray.length];
          } else if (e.key === 'ArrowLeft') {
            next = tabArray[(index - 1 + tabArray.length) % tabArray.length];
          } else if (e.key === 'Home') {
            next = tabArray[0];
          } else if (e.key === 'End') {
            next = tabArray[tabArray.length - 1];
          }

          if (next) {
            e.preventDefault();
            next.click();
            next.focus();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elation-product-usage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.elation-product-usage[data-animate-section]');
    if (!section) return;

    // Respect reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      section.classList.add('elation-usage-animate');
      return;
    }

    // Feature detect IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      section.classList.add('elation-usage-animate');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('elation-usage-animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
